module.exports = __webpack_public_path__ + "static/media/background-image_imac.8eaef7b2.jpg";